import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const CardLineItems = ({ children }: Props) => (
  <div className={'!p-3 rounded border border-card-border-color'}>
    {children}
  </div>
);

export default CardLineItems;
